import { EntityConfig } from "../..";

export const DespesasTableConfigs : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
    },
    {
      id: 'name',
      label: 'Nome',
      type: 'text',
      filterable: true
    },
    {
      id: 'value',
      label: 'Valor',
      type: 'number',
      displayInfo: 'currency'
    },
    {
      id: 'dueDate',
      label: 'Data limite',
      type: 'date',
      filterable: true
    },
    {
      id: 'paymentDate',
      label: 'Data de pagamento',
      type: 'date',
      filterable: true
    },

    {
      id: 'paid',
      label: 'Pago',
      type: 'boolean',
      filterable: true
    }
  ];
  